import { render, staticRenderFns } from "./NumericalNPC.vue?vue&type=template&id=7281637a&scoped=true"
import script from "./NumericalNPC.vue?vue&type=script&lang=js"
export * from "./NumericalNPC.vue?vue&type=script&lang=js"
import style0 from "./NumericalNPC.vue?vue&type=style&index=0&id=7281637a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281637a",
  null
  
)

export default component.exports